import { LoadingOutlined } from '@ant-design/icons';
import { Col, Row, Spin } from 'antd';
import DataGrid, { Column, ColumnFixing, Editing, Export, FilterRow, HeaderFilter, Lookup, Pager, Paging, Sorting } from 'devextreme-react/data-grid';
import { NumericFormat } from 'react-number-format';

import { useTableFundraisingLink } from '../../../Hooks/useTableFundraisingLink/useTableFundraisingLink';

interface ITableFundraisingLink {
    baseURL: string | undefined;
    clientId: string;
    language: string;
    moduleRole: string;
}

const TableFundraisingLink = ({ baseURL, clientId, language, moduleRole }: ITableFundraisingLink) => {
    const { loading, rows, candidates, setFundraisingSelection, renderLinkAction, renderCreateAction } = useTableFundraisingLink(baseURL, clientId, moduleRole);

    const moneyCell = (value: number | undefined) => (
        <NumericFormat value={value} displayType="text" thousandSeparator={language === 'es' ? '.' : ','} decimalSeparator={language === 'es' ? ',' : '.'} prefix="€" />
    );

    return (
        <Row className="table-fundraising-link" justify="center">
            <Col span={24}>
                <Spin spinning={loading} indicator={<LoadingOutlined style={{ fontSize: 34, color: 'black' }} spin />}>
                    <DataGrid id="table-fundraising-link-grid" dataSource={rows} keyExpr="contractId" showBorders={true} height="75vh" rowAlternationEnabled={true} showRowLines={true} hoverStateEnabled={true} allowColumnResizing={true} columnResizingMode="widget" columnMinWidth={100}>
                        <HeaderFilter visible={true} />
                        <Export enabled={true} />
                        <Sorting mode="multiple" />
                        <ColumnFixing enabled={true} />
                        <FilterRow visible={true} />
                        <Editing mode="cell" useIcons={true} allowUpdating={moduleRole !== 'Read'} />
                        <Paging defaultPageSize={100} />
                        <Pager showPageSizeSelector={true} allowedPageSizes={[20, 50, 100]} showNavigationButtons={true} showInfo={true} />

                        <Column dataField="contractId" caption="Contract ID" allowEditing={false} width={100} />
                        <Column dataField="name" caption="Name" allowEditing={false} minWidth={180} />
                        <Column dataField="vehicle" caption="Vehicle" allowEditing={false} minWidth={160} />
                        <Column dataField="commitment" caption="Commitment" allowEditing={false} alignment="right" cellRender={cell => moneyCell(cell.data.commitment)} />
                        <Column dataField="fundraisingId" caption="DC ID" minWidth={230} setCellValue={setFundraisingSelection} editorOptions={{ searchEnabled: true, searchExpr: ['id', 'name', 'displayLabel'] }}>
                            <Lookup dataSource={candidates} valueExpr="id" displayExpr="displayLabel" />
                        </Column>
                        <Column dataField="dcName" caption="DC Name" allowEditing={false} minWidth={180} />
                        <Column dataField="dcVehicle" caption="DC Vehicle" allowEditing={false} minWidth={160} />
                        <Column dataField="dcCommitment" caption="DC Commitment" allowEditing={false} alignment="right" cellRender={cell => moneyCell(cell.data.dcCommitment)} />
                        <Column caption="Actions" width={120} fixed={true} fixedPosition="right" allowEditing={false} allowFiltering={false} allowHeaderFiltering={false} cellRender={cell => (
                            <div>
                                {renderCreateAction(cell)}
                                {renderLinkAction(cell)}
                            </div>
                        )} />
                    </DataGrid>
                </Spin>
            </Col>
        </Row>
    );
};

export default TableFundraisingLink;
